import { FormField, getErrors } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type ToggleGroupFieldProps = {
  options: Array<{ label: string; value: string }>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function ToggleGroupField(props: ToggleGroupFieldProps) {
  const { options, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <>
          {options.map((option) => (
            <label>
              <input
                name={field.name}
                type="radio"
                value={option.value}
                onChange={(event) => field.handleChange(event.target.value)}
              />
              {option.label}
            </label>
          ))}
        </>
      }
    />
  );
}
